var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScoreTrayChevron = function SvgScoreTrayChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 10.26a.75.75 0 0 0 1.06.04L8 6.773l3.74 3.527a.75.75 0 1 0 1.02-1.1l-4.25-4a.75.75 0 0 0-1.02 0l-4.25 4a.75.75 0 0 0-.04 1.06Z",
    opacity: 0.5
  })));
};

export { SvgScoreTrayChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTMuMjAwNDEgMTAuMjYwM0MzLjQ4MjI2IDEwLjU2MzkgMy45NTY4MSAxMC41ODE0IDQuMjYwMzQgMTAuMjk5Nkw4IDYuNzczNDhMMTEuNzM5NyAxMC4yOTk2QzEyLjA0MzIgMTAuNTgxNCAxMi41MTc3IDEwLjU2MzkgMTIuNzk5NiAxMC4yNjAzQzEzLjA4MTUgOS45NTY4MSAxMy4wNjM5IDkuNDgyMjYgMTIuNzYwMyA5LjIwMDRMOC41MTAzNCA1LjIwMDRDOC4yMjI1OCA0LjkzMzIgNy43Nzc0MyA0LjkzMzIgNy40ODk2NyA1LjIwMDRMMy4yMzk2NiA5LjIwMDRDMi45MzYxMyA5LjQ4MjI2IDIuOTE4NTYgOS45NTY4MSAzLjIwMDQxIDEwLjI2MDNaIiBvcGFjaXR5PSIwLjUiIC8+Cjwvc3ZnPgogIA==";